import { render, staticRenderFns } from "./stockMovementsDeltaTable.vue?vue&type=template&id=5e05a3e0&"
import script from "./stockMovementsDeltaTable.vue?vue&type=script&lang=ts&"
export * from "./stockMovementsDeltaTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports